import type { TagPart } from 'src/contracts/querySelections';

export const getTagsValue = (item: { tags: TagPart[] }) =>
  item.tags.length > 0 ? item.tags.map((t) => t.type?.Name).join(', ') : '-';
